import React, { useContext, useEffect, useRef } from "react";

import { ReactComponent as TranslationIcon } from "../../assets/Feature/translationsIcon.svg";
import { ReactComponent as CardPayIcon } from "../../assets/Feature/CardPayIcon.svg";
import { ReactComponent as MembersToTeam } from "../../assets/Feature/MembersToTeam.svg";

import { AuthContext } from "../../Context/AuthContext";
import { DataContext } from "../../Context/DataContext";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import Lottie from "lottie-react";
import { useInView } from "react-intersection-observer";

import uniqFeature from '../../assets/LottieAnimation/uniqFeature.json';
import flexiblePaymentOption from '../../assets/LottieAnimation/flexiblePaymentOption.json';
import addMember from '../../assets/LottieAnimation/addMember.json';

const UniqueFeatures = ({ customButton, customButtonText, customButtonLink}) => {

  
  const lottieRef1 = useRef();
  const lottieRef2 = useRef();
  const lottieRef3 = useRef();

  const { ref: ref1, inView: inView1 } = useInView({
    threshold: 0.5,
    rootMargin: "-25% 0px -25% 0px", 
  });

  const { ref: ref2, inView: inView2 } = useInView({
    threshold: 0.5,
    rootMargin: "-25% 0px -25% 0px",
  });

  const { ref: ref3, inView: inView3 } = useInView({
    threshold: 0.5,
    rootMargin: "-25% 0px -25% 0px",
  });

  useEffect(() => {
    inView1 ? lottieRef1.current?.play() : lottieRef1.current?.pause();
  }, [inView1]);

  useEffect(() => {
    inView2 ? lottieRef2.current?.play() : lottieRef2.current?.pause();
  }, [inView2]);

  useEffect(() => {
    inView3 ? lottieRef3.current?.play() : lottieRef3.current?.pause();
  }, [inView3]);


  const { transitionTo } = useScreenTransition();

  const { signedIn } = useContext(AuthContext);
  const { userData, order, setOrder } = useContext(DataContext);

  const gotoOrder = () => {
    if (!signedIn) {
      transitionTo("/order/type");
      return;
    }
    if (signedIn && (userData.accountType === "personal" || !userData.teamId)) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "personal" })
      );
      setOrder((q) => ({ ...q, type: "personal" }));
    } else if (
      signedIn &&
      (userData.accountType === "business" || userData.teamId)
    ) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "business" })
      );
      setOrder((q) => ({ ...q, type: "business" }));
    }
  };

  return (
    <div className="pt-5" id="features">
      <div className=" bg-white rounded-4xl md:p-8 p-4 shadow-md w-full">
        <h2 className="my-8 mb-12 font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-center">
          Our unique features
        </h2>
        <div className="grid grid-cols-1 gap-5 w-full">
          <div className="md:grid md:grid-cols-2 flex flex-col-reverse gap-5">
            <div className="flex flex-col justify-between py-8 lg:px-12">
              <div className="flex flex-col justify-center items-flex-start text-left max-md:items-center max-md:text-center">
                <h2 className="flex gap-2 font-secondary font-medium md:text-4xl text-3xl text-tertiary items-end">
                  Get <TranslationIcon /> translated
                </h2>
                <h2 className="font-secondary font-medium md:text-4xl text-3xl text-tertiary">
                  in 4 hours or less
                </h2>
                <p className="mt-4 text-[#686F7B] text-base xl:w-2/3">
                  Submit your documents in the morning and receive certified
                  translations by noon—perfect for urgent cases and tight
                  deadlines.
                </p>
              </div>
              <div className="mt-4">
                {customButton ? customButton : <button
                  className="border border-tertiary text-tertiary rounded-full px-16 py-2 md:w-fit w-full text-center font-semibold hover:scale-[1.02] transition-all duration-300"
                  onClick={(e) => customButtonLink ? customButtonLink(e) : gotoOrder(e)}
                >
                  {customButtonText ? customButtonText : "Create Order"}
                </button>}
              </div>
            </div>

            <div ref={ref1} className="rounded-4xl overflow-hidden lg:h-[500px] md:h-[400px] h-[350px] relative">

              <Lottie
               lottieRef={lottieRef1}
                animationData={uniqFeature}
                loop
                autoplay={false}
                className="h-full w-full object-cover" />

            </div>
          </div>

          <div className="md:grid md:grid-cols-2 flex flex-col-reverse gap-5">
            <div className="flex flex-col justify-between py-8 lg:px-12">
              <div className="flex flex-col justify-center items-flex-start text-left max-md:items-center max-md:text-center">
                <h2 className="flex gap-2 font-secondary font-medium md:text-4xl text-3xl text-tertiary items-end">
                  Flexible <CardPayIcon /> payment
                </h2>
                <h2 className="font-secondary font-medium md:text-4xl text-3xl text-tertiary">
                  options{" "}
                </h2>

                <div className=" md:hidden block border border-[#7245ED] text-[#7245ED] uppercase mt-4 rounded-full px-4 py-1 w-fit text-center font-semibold">
                  for businesses accounts
                </div>
                <p className="mt-4 text-[#686F7B] text-base xl:w-2/3">
                  Choose monthly, biweekly, or custom schedules. You can also
                  share payment links with your clients for added convenience.
                </p>

                <div className="md:block hidden border border-[#7245ED] text-[#7245ED] uppercase mt-4 rounded-full px-4 py-1 w-fit text-center font-semibold">
                  for businesses accounts
                </div>
              </div>
              <div className="mt-4">
                {customButton ? customButton : <button
                  className="border border-tertiary text-tertiary rounded-full px-16 py-2 md:w-fit w-full text-center font-semibold hover:scale-[1.02] transition-all duration-300"
                  onClick={(e) => customButtonLink ? customButtonLink(e) : gotoOrder(e)}
                >
                  {customButtonText ? customButtonText : "Create Order"}
                </button>}
              </div>
            </div>

          
            <div ref={ref2} className="rounded-4xl overflow-hidden lg:h-[500px] md:h-[400px] h-[350px] relative">

              <Lottie
               lottieRef={lottieRef2}
                animationData={flexiblePaymentOption}
                loop
                autoplay={false}
                
                className="h-full w-full object-cover" />
            </div>
          </div>

          <div className="md:grid md:grid-cols-2 flex flex-col-reverse gap-5">
            <div className="flex flex-col justify-between py-8 lg:px-12">
              <div className="flex flex-col justify-center items-flex-start text-left max-md:items-center max-md:text-center">
                <h2 className="flex gap-2 font-secondary font-medium md:text-4xl text-3xl text-tertiary items-end">
                  Add <MembersToTeam /> members
                </h2>
                <h2 className="font-secondary font-medium md:text-4xl text-3xl text-tertiary">
                  to your team
                </h2>
                <div className=" md:hidden block border border-[#7245ED] text-[#7245ED] uppercase mt-4 rounded-full px-4 py-1 w-fit text-center font-semibold">
                  for businesses accounts
                </div>

                <p className="mt-4 text-[#686F7B] text-base xl:w-2/3">
                  Collaborate seamlessly by inviting colleagues to manage orders
                  together and track progress—all in one place.
                </p>

                <div className="md:block hidden border border-[#7245ED] text-[#7245ED] uppercase mt-4 rounded-full px-4 py-1 w-fit text-center font-semibold">
                  for businesses accounts
                </div>
              </div>
              <div className="mt-4">
                {customButton ? customButton : <button
                  className="border border-tertiary text-tertiary rounded-full px-16 py-2 md:w-fit w-full text-center font-semibold hover:scale-[1.02] transition-all duration-300"
                  onClick={(e) => customButtonLink ? customButtonLink(e) : gotoOrder(e)}
                >
                  {customButtonText ? customButtonText : "Create Order"}
                </button>}
              </div>
            </div>

            <div ref={ref3} className="rounded-4xl overflow-hidden lg:h-[500px] md:h-[400px] h-[350px] relative">

              <Lottie
               lottieRef={lottieRef3}
                animationData={addMember}
                autoplay={false}
                loop
               
                className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniqueFeatures;
